module.exports = __webpack_public_path__ + "assets/img/bigBgBorder.e41aaf7f.png";